export default __webpack_public_path__ + "static/media/style.module.19fdd33a.less";